import React from "react";

const BillCardFake = () => {
  return (
    <>
      <section className="bill-card-fake">
        <div className="bill-card-fake--info">
          <div className="skeleton bill-card-fake--info--title" />
          <div className="skeleton bill-card-fake--info--price" />
        </div>
        <div className="bill-card-fake--info-2">
          <div className="skeleton bill-card-fake--info-2--date" />
        </div>
        <div className="bill-card-fake--info-2">
          <div className="skeleton bill-card-fake--info-2--link" />
          <div className="skeleton bill-card-fake--info-2--link" />
        </div>
      </section>
      <style jsx>{`
        .bill-card-fake {
          padding: 1rem;
          border: 1px solid #dddddd;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: start;
          width: 100%;
          gap: 1rem;
          &--info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            &--title {
              height: 22px;
              width: 200px;
            }
            &--price {
              height: 22px;
              width: 10%;
            }
          }
          &--info-2 {
            display: flex;
            flex-direction: row;
            gap: 1rem;
            width: 100%;
            &--date {
              height: 16px;
              width: 40%;
            }
            &--link {
              height: 14px;
              width: 20%;
            }
          }
        }
        @media (min-width: 768px) {
          .bill-card-fake {
            width: 49%;
          }
        }
      `}</style>
    </>
  );
};

export default BillCardFake;
